import {
  Box,
  Button,
  Text,
  useColorModeValue,
  useDisclosure,
} from "@chakra-ui/react";
import { useContext } from "react";
import { useTranslation } from "react-i18next";
import { AuthContext } from "../store/auth-context";
import PaywallModal from "./PaywallModal";
import { usePremiumAccess } from "../hooks/usePremiumAccess";

const SettingsPremiumBanner = () => {
  const { t } = useTranslation();
  const AuthCtx = useContext(AuthContext);
  const { isPremium } = usePremiumAccess();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const userId = AuthCtx.authenticatedUser?.id;

  const shellBg = useColorModeValue("brand.50", "rgba(52,211,153,0.1)");
  const shellBorder = useColorModeValue("brand.200", "whiteAlpha.200");
  const titleColor = useColorModeValue("gray.900", "white");
  const bodyColor = useColorModeValue("gray.600", "whiteAlpha.700");
  const kickerColor = useColorModeValue("brand.700", "brand.300");

  if (isPremium) return null;

  return (
    <>
      <Box px={3} py={2}>
        <Box
          position="relative"
          overflow="hidden"
          borderRadius="lg"
          border="1px solid"
          borderColor={shellBorder}
          bg={shellBg}
          px={2.5}
          py={2}
        >
          <Box
            position="absolute"
            left={0}
            top={0}
            bottom={0}
            w="3px"
            bgGradient="linear(to-b, brand.400, brand.600)"
            aria-hidden
          />
          <Text
            fontSize="9px"
            fontWeight="bold"
            letterSpacing="0.08em"
            textTransform="uppercase"
            color={kickerColor}
            mb={0.5}
            pl={1}
          >
            {t("settings.premiumUpsellKicker")}
          </Text>
          <Text fontSize="xs" fontWeight="semibold" color={titleColor} lineHeight="1.25" pl={1}>
            {t("settings.premiumUpsellTitle")}
          </Text>
          <Text fontSize="10px" color={bodyColor} lineHeight="1.35" mt={1} mb={2} pl={1}>
            {t("settings.premiumUpsellBody")}
          </Text>
          <Button
            size="xs"
            w="100%"
            h="28px"
            minH="28px"
            borderRadius="md"
            fontWeight="semibold"
            fontSize="10px"
            bgGradient="linear(to-r, brand.400, brand.600)"
            color="gray.900"
            _hover={{
              bgGradient: "linear(to-r, brand.500, brand.600)",
              transform: "translateY(-1px)",
            }}
            _active={{ transform: "translateY(0)" }}
            onClick={onOpen}
          >
            {t("settings.premiumUpsellCta")}
          </Button>
        </Box>
      </Box>

      <PaywallModal isOpen={isOpen} onClose={onClose} userId={userId} size="2xl" />
    </>
  );
};

export default SettingsPremiumBanner;
